import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MeesageDialogComponent } from 'src/app/admin/dialog/meesage-dialog/meesage-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormsConfirmationMessageComponent } from '../dialogs/forms-confirmation-message/forms-confirmation-message.component';
import { Links, RtaAttachements } from 'src/app/shared/models/admin.model';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { User } from 'src/app/shared/models/user.model';
import { RTA_DISPOSITION_VISIBLE_STATUSES, RTAStatus, UserRoles } from 'src/app/app.constants';
import { SolarFormsRepositoryService } from 'src/app/services/solarForms/solar-forms-repository.service';
import { RTALookupService } from 'src/app/services/solarForms/rta-lookup.service';
import { RTALookupItem } from 'src/app/shared/models/rta-lookup.model';
import { SupplierDetails } from 'src/app/shared/models/documents.model';
import { RTADetails } from 'src/app/shared/models/solarForms.model';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DocumentsRepositoryService } from 'src/app/services/documents-repository.service';
import { HttpResponse } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-create-rta-form',
  templateUrl: './create-rta-form.component.html',
  styleUrls: ['./create-rta-form.component.scss']
})
export class CreateRTAFormComponent implements OnInit {
  //today = new Date();
  //tomorrow = new Date();
  RTAForm: UntypedFormGroup;
  restrictPattern =  '^[^\\/"<>|*?]+$';
  integersPattern =  '^[0-9]+$';
  //"^[a-zA-Z0-9!@#%^&()_+\-=\[\]{};':&quot;,.?&lt;&gt;\\ ]+$";
  //"^[\\/*?&quot;&lt;&gt;|]+$";      
  //"^[^\\/*?&quot;&lt;&gt;|]*$";

  @ViewChild('scrollSection',{static: false}) scrollSection: ElementRef;
  @ViewChild('scrollToProposed',{static: false}) scrollToProposed: ElementRef;
  isProposedDurationValid: boolean;
  linkList: Links[] = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  user: User;
  supplierResults: any[];
  fileResponse: any;
  linkListAddress: string;
   acceptedFileExtensions = [];
  isQauntityRequire: boolean;
  quantityInvalid: boolean = true;
  isRTAFormDirty: boolean;
  supllierInfo: SupplierDetails;
  //makeButtonDisable: boolean;
  getEditRTAInfo: any;
  generalRTAInformation: any;
  rtaReqDetails: any;
  rtaCurrentCondition: any;
  isRTAEditForm: boolean = false;
  rtaDisposition: any;
  supplierIndex: number;
  isRTAReadOnly: boolean = false;
  isLoadingData: boolean;
  // Shown under the spinner so a multi-second Windchill round-trip reads as
  // "working" rather than "broken".
  loadingMessage: string = '';
  isRTASaveDraft: boolean = false;
  isRTAFormSubmit: boolean;
  // PBI 368007-Part2 / Windchill Q10: true after supplier field is auto-populated
  // from the logged-in supplier user. Used by the template to suppress the
  // required-marker asterisk on that field.
  isSupplierAutoPopulated: boolean = false;

  // Windchill controlled-vocabulary options (PBI 368007-Part2). Loaded on init
  // from /RTALookup/GetByDomain. docType is intentionally not loaded/rendered
  // (Windchill sets a default per open Q12 answer).
  // Windchill accepts up to section1BInlineCap Section 1B rows inline in the
  // submit payload. Above that (and up to section1BMaxRows) the rows are
  // submitted to Windchill as a generated Word (.docx) attachment instead of
  // inline (Windchill team overflow guidance).
  readonly section1BInlineCap = 12;
  readonly section1BMaxRows = 100;
  // Master switch (default off): while disabled the form hard-caps Section 1B at
  // section1BInlineCap and the overflow-to-.docx feature is fully hidden.
  readonly section1BFeatureEnabled = environment.rtaSection1BOverflowEnabled;
  // TEMP toggle (API appsettings RTA:AllowAdminSubmit, fetched on init): ADMIN users
  // can create/save/submit an RTA on behalf of a supplier chosen from the
  // Supplier / CAM Name dropdown. Remove once no longer needed.
  allowAdminSubmit: boolean = false;
  // Windchill stamps every RTA's Department as ENG and asked SG not to send it;
  // the form mirrors the value read-only.
  readonly fixedDepartment = 'ENG';
  // Always External from SG's side; Windchill may change it later and the form
  // then shows Windchill's value, but the submitter never controls it.
  readonly fixedRoutingType = 'External';
  valueStreamOptions: RTALookupItem[] = [];
  productModelOptions: RTALookupItem[] = [];
  deviationPermitOptions: RTALookupItem[] = [];
  dispositionOptions: RTALookupItem[] = [];
  section1BCapReached: boolean = false;
  // True once the row count exceeds the inline cap: the extra rows (in fact all
  // rows) will be submitted to Windchill as an attached .docx.
  section1BOverflow: boolean = false;

  // TEMP (manual verification): download link for the generated Section 1B
  // overflow .docx so the exact document that would be uploaded to Windchill can
  // be inspected. Remove once verified.
  testDocUrl: SafeUrl | null = null;
  testDocFileName: string = '';
  private testDocObjectUrl: string | null = null;
  // Never expose the manual-verification button/link in production builds.
  readonly showOverflowDocTest = !environment.production;

  // rtaStatus may carry Windchill's raw lifecycle state ("DISPOSITIONED") or SG's
  // display value ("Dispositioned") depending on whether the payload was hydrated
  // from Windchill or the local record, so every comparison goes through here.
  private get normalizedRtaStatus(): string {
    return (this.generalRTAInformation?.rtaStatus || '').trim().toLowerCase();
  }

  private isRtaStatus(...statuses: string[]): boolean {
    const current = this.normalizedRtaStatus;
    return statuses.some(s => (s || '').trim().toLowerCase() === current);
  }

  get showDispositionSection(): boolean {
    return this.isRtaStatus(...RTA_DISPOSITION_VISIBLE_STATUSES);
  }

  get isDraftRtaStatus(): boolean {
    return this.isRtaStatus(RTAStatus.Draft, RTAStatus.NotSubmitted);
  }

  get isAdminOnBehalf(): boolean {
    return this.allowAdminSubmit && this.user?.roleId === UserRoles.ADMIN;
  }

  // "Not Submitted" is a server-derived display label, not a stored state; drafts
  // are persisted as 'Draft' so RTAJson keeps its original vocabulary.
  private get persistedRtaStatus(): string {
    return this.isRtaStatus(RTAStatus.NotSubmitted) ? RTAStatus.Draft : this.generalRTAInformation?.rtaStatus;
  }

  get isSupplierRole(): boolean {
    return this.user?.roleId === UserRoles.SUPPLIER || this.user?.roleId === UserRoles.SUPPLIER_ENG_QUALITY;
  }

  // Roles allowed to author an RTA (create, save draft, submit).
  get canAuthorRta(): boolean {
    return this.isSupplierRole || this.isAdminOnBehalf;
  }

  compareSuppliers(a: any, b: any): boolean {
    return a && b ? a.id === b.id : a === b;
  }

  constructor(private fb: UntypedFormBuilder,
              private documentsService: DocumentsRepositoryService,
              private navigationPreviousPage: Location,
              private dialog: MatDialog,
              private snackBarService: SnackBarService,
              private route: ActivatedRoute,
              private userRepositoryService: UserRepositoryService,
              private solarFormsService: SolarFormsRepositoryService,
              private rtaLookupService: RTALookupService,
              private sanitizer: DomSanitizer) {

  }

  ngOnInit(): void {
    // The route alone tells us whether an existing RTA is being opened, so show the
    // spinner on first paint instead of after the user/supplier prefetches resolve.
    const initial = this.route.snapshot.paramMap;
    const openingExisting = (initial.get('mode') && initial.get('id'))
      || (initial.get('status') && initial.get('status') !== 'createRTA');
    if (openingExisting) {
      this.beginLoading(initial.get('mode') === 'draft'
        ? 'Loading RTA…'
        : 'Retrieving the latest RTA details from Windchill…');
    }

    this.rtaFormInitialize();
    this.addRemoveValidators();
    this.loadRTALookups();
    // The flag must be known before the role branch below decides whether the
    // form is editable, so the user/supplier prefetch is chained behind it.
    this.solarFormsService.getRTAFeatureFlags()
     .pipe(takeUntil(this.unsubscribe))
     .subscribe((flags) => {
     this.allowAdminSubmit = !!flags?.allowAdminSubmit;
    this.userRepositoryService.loggedUserData$
     .pipe(takeUntil(this.unsubscribe))
     .subscribe((user) => { 
       this.user = user;
     this.userRepositoryService.getSuppliersByUserId(user.cwsId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        const supplierFiltered = res.filter(function (el) {
          return el != null;
        });
        this.route.paramMap.subscribe((params: ParamMap) => {
          // PBI 314702 — new route pattern uses :mode + :id ("edit"/"draft"/"view").
          // Legacy route pattern uses :status ("createRTA" or an RTA number).
          const mode = params.get('mode');
          const routeId = params.get('id');
          if (mode && routeId) {
            this.initFromEditModeRoute(mode, routeId, supplierFiltered);
            return;
          }

          let id = params.get('status');
          if (id != 'createRTA') {
            this.editFormInitliaze(id);
            this.supplierResults = supplierFiltered;
            this.showSupplier();
          } else {
            if (this.canAuthorRta) {
              this.supplierResults = supplierFiltered;
              this.showSupplier();
              //this.isLoadingData = true;
            } else {
              this.RTAForm.disable();
              this.isRTAReadOnly = true;
            }
          }
        });
      });
    });
    });
  }

  /**
   * PBI 314702 — handles the new /RTAForm/:mode/:id route pattern. Fetches the
   * resolved payload from the backend and applies read-only when mode==='view'.
   * Falls back to the legacy edit flow if the resolver endpoint fails so the
   * user is never left on a broken screen.
   */
  private initFromEditModeRoute(mode: string, routeId: string, supplierList: any[]): void {
    const normalized = (mode || '').toLowerCase();
    const urlReadOnly = normalized === 'view';
    const isLocalDraft = normalized === 'draft';

    const rtaNumber = isLocalDraft ? null : routeId;
    const localId = isLocalDraft ? routeId : null;

    this.beginLoading(isLocalDraft
      ? 'Loading RTA…'
      : 'Retrieving the latest RTA details from Windchill…');
    this.solarFormsService.getRTAForEdit(rtaNumber, localId).subscribe({
      next: (result) => {
        const backendModeKey = this.resolveBackendModeKey(result?.mode);
        const backendReadOnly = backendModeKey === 'ReadOnly';
        const isReadOnly = urlReadOnly || backendReadOnly;

        if (!result || !result.rtaDetails) {
          this.editFormInitliaze(routeId);
          this.supplierResults = supplierList;
          this.showSupplier();
          if (isReadOnly) this.readOnlyRTAForm();
          return;
        }
        this.getEditRTAInfo = result.rtaDetails;
        this.isRTAEditForm = true;
        this.generalRTAInformation = result.rtaDetails.generalRTAInformation || {};
        this.rtaReqDetails = result.rtaDetails.rtaRequestDetails || {};
        this.rtaCurrentCondition = result.rtaDetails.rtaCurrentCondition || { currentConditions: [] };
        this.rtaDisposition = result.rtaDetails.rtsDisposition || {};
        this.supplierResults = supplierList;
        this.editFormValueBinding();
        this.showSupplier();
        if (isReadOnly) {
          this.readOnlyRTAForm();
        }
        this.endLoading();
      },
      error: () => {
        this.editFormInitliaze(routeId);
        this.supplierResults = supplierList;
        this.showSupplier();
        if (urlReadOnly) this.readOnlyRTAForm();
      }
    });
  }

  private beginLoading(message: string): void {
    this.loadingMessage = message;
    this.isLoadingData = true;
  }

  private endLoading(): void {
    this.isLoadingData = false;
    this.loadingMessage = '';
  }

  // Backend currently returns numeric enum values (0=Edit, 1=EditDraft, 2=ReadOnly)
  // but this also tolerates string enum names if API serialization changes later.
  private resolveBackendModeKey(mode: any): string | null {
    if (mode === undefined || mode === null) return null;
    if (typeof mode === 'number') {
      const map = ['Edit', 'EditDraft', 'ReadOnly'];
      return map[mode] || null;
    }
    return String(mode);
  }

  editFormInitliaze(id) {
    // Also the fallback target when the Windchill-backed load fails, so it must
    // always clear the spinner itself.
    if (!this.isLoadingData) { this.beginLoading('Loading RTA…'); }
    this.solarFormsService.getRTAFormDetailsById(id)
      .pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
        this.getEditRTAInfo = data;
        if(this.getEditRTAInfo) {
          this.isRTAEditForm = true;
          this.generalRTAInformation = data.generalRTAInformation;
          this.rtaReqDetails = data.rtaRequestDetails;
          this.rtaCurrentCondition = data.rtaCurrentCondition;
          this.rtaDisposition = data.rtsDisposition;
          this.editFormValueBinding();
          if(this.user) {
          const internalReadOnlyRole = this.user.roleId === UserRoles.SUPPLYCHAIN || this.user.roleId === UserRoles.ENGINEERING
            || (this.user.roleId === UserRoles.ADMIN && !this.isAdminOnBehalf);
          if(internalReadOnlyRole && 
          this.isRtaStatus(RTAStatus.Approved, RTAStatus.Draft, RTAStatus.NotSubmitted, RTAStatus.Submitted)
            ) {
            this.readOnlyRTAForm();
           } else if (this.canAuthorRta &&
             this.isRtaStatus(RTAStatus.Approved)) {
             this.readOnlyRTAForm();
          }
        }
        }
        this.endLoading();
      }, () => {
        this.endLoading();
        this.snackBarService.showError('Unable to load the RTA. Please try again later.');
      });
  }

  editFormValueBinding() {
   this.supplierResults.filter((val, i )=>{
      if(val.organizationCode == this.rtaReqDetails.supplierCode){
        this.supplierIndex = i;
      }
    })
    this.currentCondition.clear();
    //this.supplierResults = this.rtaReqDetails;
    this.supplierReference.patchValue(this.generalRTAInformation.supplierPreference);
    this.supplierOrCamName.patchValue(this.supplierResults[this.supplierIndex]);
    // Windchill contract header fields (PBI 368007-Part2).
    this.partNumber.patchValue(this.generalRTAInformation.partNumber || '');
    this.department.patchValue(this.fixedDepartment);
    this.valueStream.patchValue(this.generalRTAInformation.valueStream || '');
    this.routingType.patchValue(this.generalRTAInformation.routingType || this.fixedRoutingType);
    this.productModel.patchValue(this.generalRTAInformation.productModel || '');
    this.email.patchValue(this.rtaReqDetails.email);
    this.phone.patchValue(this.rtaReqDetails.phone);
    this.solarPurchaseOrder.patchValue(this.rtaReqDetails.solarPurchaseOrderNumber);
    this.solarProductionOrder.patchValue(this.rtaReqDetails.solarProductionNumber);
    this.operation.patchValue(this.rtaReqDetails.operationNumber);
    //this.isNonconformingConditionCtq.patchValue(this.rtaReqDetails.isNonconformingConditionCTQ == false ? 'No' : 'Yes');
    this.isNonconformingConditionCtq.patchValue(this.rtaReqDetails.isNonconformingConditionCTQ == false ? 'No' : (this.rtaReqDetails.isNonconformingConditionCTQ == true ? 'Yes' : null) ),
    this.causeOfNonconformance.patchValue(this.rtaReqDetails.causeOfNonConformance);
    this.proposedCorrection.patchValue(this.rtaReqDetails.proposeCorrection);
    this.commentsOrSrp.patchValue(this.rtaReqDetails.comments);
    this.quantityOfNonconformingParts.patchValue(this.rtaReqDetails.proposedDuration.quantityOfNonconformingParts);
    this.fromDate.patchValue(this.rtaReqDetails.proposedDuration.fromDate);
    this.toDate.patchValue(this.rtaReqDetails.proposedDuration.toDate);
    this.rtaCurrentCondition.currentConditions.forEach(val => {
      const formgroup = new UntypedFormGroup({
        drawingOrSpecRequirement: this.fb.control(val.drawingSpecRequirement == null ? '' : val.drawingSpecRequirement, [Validators.required]),
        bluePrintZoneSection: this.fb.control(val.bluePrintZoneSpecSection == null ? '' : val.bluePrintZoneSpecSection, [Validators.required]),
        actualCondition: this.fb.control(val.actualCondition, [Validators.required]),
        quantity: this.fb.control(val.quantity, [Validators.required]),
        serialNumber:  this.fb.control(val.serialNumber == null ? '' : val.serialNumber),
        additionalComments: this.fb.control(val.additionalComments == null ? '' : val.additionalComments),
        disposition:  this.fb.control(val.disposition == null ? '' : val.disposition),
        dispositionNotes: this.fb.control(val.dispositionNotes == null ? '' : val.dispositionNotes),
      });

      this.currentCondition.push(formgroup);
    });
    this.linkList = this.rtaCurrentCondition.rtaAttachments;
    this.updateSection1BFlags();
    // if(this.generalRTAInformation.rtaStatus == 'Draft') {
    //    // this.isSaveDraft
    // }
  }

  readOnlyRTAForm() {
    this.RTAForm.disable();
    this.isRTAReadOnly = true;
  }

  private showSupplier(): void {
    if (this.isAdminOnBehalf) {
      // TEMP admin-on-behalf: the supplier is picked from the dropdown (or comes
      // from the stored RTA when editing), never derived from the admin's account.
      if (!this.email.value) { this.email.setValue(this.user.email); }
      this.isSupplierAutoPopulated = false;
      this.supplierOrCamName.enable({ emitEvent: false });
      return;
    }
    const getSupplier = this.supplierResults.filter(
      (x) => x.id === this.user.supplierId
    );
    this.supllierInfo = getSupplier[0];
    this.supplierOrCamName.setValue(getSupplier[0]);
    this.email.setValue(this.user.email);
    // PBI 368007-Part2 / Windchill Q10: supplier field is auto-populated from
    // the logged-in supplier user and must be read-only or invisible to them.
    // We render it as a plain read-only text field (see template). Disabling
    // the underlying Reactive Forms control excludes it from `required`
    // evaluation, so no validator changes are needed.
    this.isSupplierAutoPopulated = true;
    this.supplierOrCamName.disable({ emitEvent: false });
  }

  /**
   * Display string for the read-only Supplier / CAM Name field.
   * Reads from the underlying form-control value (an object populated by
   * `showSupplier()` / `editFormValueBinding()`), preserving the object shape
   * that downstream save/upload code relies on.
   */
  get supplierDisplay(): string {
    const v = this.supplierOrCamName?.value;
    if (!v) { return ''; }
    const name = v.supplierName ?? '';
    const code = v.organizationCode ?? '';
    return code ? `${name} ${code}` : name;
  }

  rtaFormInitialize() {
    this.RTAForm = this.fb.group({
      supplierReference: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
      rtaRequestDetails: this.fb.group({
        supplierOrCamName: this.fb.control('',[Validators.required]),
        // Windchill contract header fields (PBI 368007-Part2).
        partNumber: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        department: this.fb.control(this.fixedDepartment),
        valueStream: this.fb.control('',[Validators.required]),
        routingType: this.fb.control(this.fixedRoutingType),
        productModel: this.fb.control(''),
        phone: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        email: this.fb.control('',[Validators.required, this.multipleEmailValidator, this.backSlashValidator, Validators.pattern(this.restrictPattern)]),
        solarPurchaseOrder: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        solarProductionOrder: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        operation: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        isNonconformingConditionCtq: this.fb.control('',[Validators.required]),
        causeOfNonconformance: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        proposedCorrection: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        commentsOrSrp: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        quantityOfNonconformingParts: this.fb.control(''),
        fromDate: this.fb.control(''),
        toDate: this.fb.control(''),
      }),
      currentCondition: this.fb.array([
        this.fb.group({
          drawingOrSpecRequirement: this.fb.control('',[Validators.required]),
          bluePrintZoneSection: this.fb.control('',[Validators.required]),
          actualCondition: this.fb.control('',[Validators.required]),
          quantity: this.fb.control(''),
          serialNumber: this.fb.control(''),
          additionalComments: this.fb.control(''),
          disposition: this.fb.control('-'),
          dispositionNotes: this.fb.control('-'),
        })
      ]),
      filesUploadAttachment: this.fb.control('')
    });
    this.quantityOfNonconformingParts.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(val => {
      if(val) {
        let ctrl;
        if(this.currentCondition) {
          this.currentCondition.controls.forEach(a => {
            ctrl = a;
             ctrl.controls.quantity.setValidators([Validators.required]);
             ctrl.controls.quantity.updateValueAndValidity();
             //this.quantityInvalid = true;
             //ctrl.controls.quantity.markAsTouched();
             this.isQauntityRequire = true;
          })
        }
      } else {
        let ctrl;
        if(this.currentCondition) {
          this.currentCondition.controls.forEach(a => {
            ctrl = a;
             ctrl.controls.quantity.clearValidators();
             ctrl.controls.quantity.updateValueAndValidity();
             this.isQauntityRequire = false;
          })
        }
      }
    });
    this.RTAForm.valueChanges
    .subscribe(val => {
      if(this.RTAForm.dirty) {
        this.isRTAFormDirty = true;
      }
    });
    this.toDate.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(val => {
      if(val) {
        this.validateDates();
      }
    });
    this.fromDate.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(val => {
      if(val) {
        this.validateDates();
      }
    });
  }

   validateDates() {
    const from = new Date(this.fromDate.value);
    const to = new Date(this.toDate.value);
    if(from && to && from > to) {
      this.toDate.setErrors({ dateRangeError: true });
    } else {
      this.toDate.setErrors(null);
    }
   }

  backSlashValidator(control: UntypedFormControl) {
    const value = control.value;
    const hasBackSlash = value && value.includes('\\');
    return hasBackSlash ? {'hasBackSlash' : true } : null;
  }

  multipleEmailValidator(control: UntypedFormControl) { 
    const value = control.value; 
    if (value) { 
      const emailArray = value.split(','); 
      const isValid = emailArray.every(email => /\S+@\S+\.\S+/.test(email.trim())); 
      return isValid ? null : { multipleEmails: true }; 
    } 
    return null;
  }

  onAddConditionClick() {
    if (this.currentCondition.controls.length >= this.effectiveSection1BMaxRows) {
      this.section1BCapReached = true;
      this.snackBarService.showError(
        `If you have more than ${this.effectiveSection1BMaxRows} current conditions, please reach out to your STE.`
      );
      return;
    }
    const newEntry = new UntypedFormGroup({
      drawingOrSpecRequirement: this.fb.control('',[Validators.required]),
      bluePrintZoneSection: this.fb.control('',[Validators.required]),
      actualCondition: this.fb.control('',[Validators.required]),
      quantity: this.fb.control('', [this.quantityOfNonconformingParts.value != '' ? Validators.required : Validators.nullValidator]),
      serialNumber: this.fb.control(''),
      additionalComments: this.fb.control(''),
      disposition: this.fb.control('-'),
      dispositionNotes: this.fb.control('-'),
    });
    this.currentCondition.push(newEntry);
    this.updateSection1BFlags();
  }

  onDeleteIconClick(index) {
    // Server enforces the same rule; dispositions live in Windchill by row slot.
    if (this.isRowDispositioned(index)) { return; }
    this.currentCondition.controls.splice(index, 1);
    this.currentCondition.value.splice(index, 1);
    if (this.currentCondition.controls.length > 0) {
      this.currentCondition.controls.forEach((formGroup: AbstractControl) => {
        if (formGroup instanceof UntypedFormGroup) {
          Object.keys(formGroup.controls).forEach((ctrlName: string) => {
            const control = formGroup.get(ctrlName);
            if (control instanceof UntypedFormControl && control.validator) {
              control.updateValueAndValidity();
            }
          })
        }
      });
    } else {
      this.currentCondition.setErrors({ inValidCondition: true });
    }
    this.updateSection1BFlags();
  }

  /**
   * Recomputes the Section 1B row-count flags after add/delete:
   * - section1BCapReached: at the absolute max (no more rows allowed).
   * - section1BOverflow: past the inline cap, so rows will be submitted to
   *   Windchill as an attached .docx instead of inline.
   */
  private updateSection1BFlags(): void {
    const count = this.currentCondition.controls.length;
    this.section1BCapReached = count >= this.effectiveSection1BMaxRows;
    this.section1BOverflow = this.section1BFeatureEnabled && count > this.section1BInlineCap;
  }

  // Effective row cap: the inline cap while the feature is off, the absolute max when on.
  get effectiveSection1BMaxRows(): number {
    return this.section1BFeatureEnabled ? this.section1BMaxRows : this.section1BInlineCap;
  }

  /** Loads all in-scope Windchill controlled-vocabulary domains for the RTA form. */
  private loadRTALookups(): void {
    const domains: { domain: string, sink: (items: RTALookupItem[]) => void }[] = [
      { domain: 'ValueStream', sink: v => this.valueStreamOptions = v },
      { domain: 'rtaProductModel', sink: v => this.productModelOptions = v },
      { domain: 'rtaDeviationPermit', sink: v => this.deviationPermitOptions = v },
      { domain: 'Disposition', sink: v => this.dispositionOptions = v },
    ];
    domains.forEach(({ domain, sink }) => {
      this.rtaLookupService.getByDomain(domain)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(items => sink(items || []));
    });
  }

  onRtaFormSubmit() {
    if (this.RTAForm.valid) {
      if(((!this.RTAForm.get('rtaRequestDetails.fromDate').value) || (!this.RTAForm.get('rtaRequestDetails.toDate').value)) && !this.RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts').value) {
        this.isProposedDurationValid = true;
        this.scrollToProposed.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }else {
        this.isRTAFormSubmit = true;
        const RTAFormInfo = this.getRTAFormInfo();
        this.isProposedDurationValid = false;
        const dialogRef = this.dialog.open(FormsConfirmationMessageComponent, {
          disableClose: true,
          width: '650px',
          data: {
            name: 'Submit RTA',
            message: 'Do you wish to submit this RTA to be reviewed by Solar?',
            data: RTAFormInfo,
            isRTAEdit: this.isRTAEditForm
          }
        });
        // Otherwise a cancelled submit followed by Save would persist rtaStatus 'Submitted'.
        dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          this.isRTAFormSubmit = false;
        });
      }
        // submit the form
     } else {
      let scrollToIndex = -1;
      let ctrl;
      let firstInvalid = null;
      this.currentCondition.controls.find((control, index) => {
        if (control.status == 'INVALID' && scrollToIndex === -1) {
          ctrl = control;
          for(let key in ctrl.controls) {
            const invalidField = ctrl.get(key);
            if(invalidField.invalid) {
              firstInvalid = invalidField;
              break;
            }
          }
          scrollToIndex = index;
        }
      });
      if (scrollToIndex !== -1) {
        const element = document.getElementById(`scrollSection-${scrollToIndex}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if(firstInvalid) {
          //firstInvalid.focus();
          firstInvalid.markAsTouched();
        }
      }
    }
  }

  // TEMP (manual verification): sends the current Section 1B rows to the backend
  // to generate the overflow .docx and exposes a download link so the exact
  // document that would be uploaded to Windchill can be inspected. Remove later.
  onTestGenerateDocClick(): void {
    this.revokeTestDocUrl();

    const payload: any = {
      generalRTAInformation: { rtaNumber: this.generalRTAInformation?.rtaNumber || '' },
      RTACurrentCondition: {
        CurrentConditions: this.currentCondition.controls.map((control: UntypedFormGroup) => ({
          drawingSpecRequirement: control.get('drawingOrSpecRequirement')?.value,
          bluePrintZoneSpecSection: control.get('bluePrintZoneSection')?.value,
          actualCondition: control.get('actualCondition')?.value,
          quantity: control.get('quantity')?.value,
          serialNumber: control.get('serialNumber')?.value,
          AdditionalComments: control.get('additionalComments')?.value,
          disposition: control.get('disposition')?.value || '',
          dispositionNotes: control.get('dispositionNotes')?.value || '',
        }))
      }
    };

    this.isLoadingData = true;
    this.solarFormsService.testGenerateSection1BDoc(payload)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response: HttpResponse<Blob>) => {
        const blob = response.body;
        if (!blob || blob.size === 0) {
          this.isLoadingData = false;
          this.snackBarService.showError('Could not generate the document.');
          return;
        }
        this.testDocFileName = this.extractFileName(response) || 'RTA_LineItems.docx';
        this.testDocObjectUrl = URL.createObjectURL(blob);
        this.testDocUrl = this.sanitizer.bypassSecurityTrustUrl(this.testDocObjectUrl);
        this.isLoadingData = false;
      }, (error) => {
        this.isLoadingData = false;
        if (error?.error instanceof Blob) {
          error.error.text().then((text: string) => {
            let message = 'Could not generate the document.';
            try {
              const parsed = JSON.parse(text);
              if (parsed?.message) { message = parsed.message; }
            } catch { /* keep default message */ }
            this.snackBarService.showError(message);
          });
        } else {
          this.snackBarService.showError('Could not generate the document.');
        }
      });
  }

  // TEMP (manual verification): reads the suggested file name from the
  // Content-Disposition response header.
  private extractFileName(response: HttpResponse<Blob>): string {
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = /filename\*?=(?:UTF-8'')?"?([^\";]+)"?/i.exec(disposition);
    return match ? decodeURIComponent(match[1]) : '';
  }

  // TEMP (manual verification): releases the previous object URL to avoid leaks.
  private revokeTestDocUrl(): void {
    if (this.testDocObjectUrl) {
      URL.revokeObjectURL(this.testDocObjectUrl);
      this.testDocObjectUrl = null;
    }
    this.testDocUrl = null;
    this.testDocFileName = '';
  }

  onRtaSaveDraftClick() {
    this.isRTASaveDraft = true;
    this.isLoadingData = true;
    const RTAFormInfo = this.getRTAFormInfo();
    if(!this.isRTAEditForm) {
      this.solarFormsService.saveRTAFormInfo(RTAFormInfo)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if(data) {
          this.snackBarService.showSuccess(`RTA saved successfully.`); 
          this.navigationPreviousPage.back();
          this.isLoadingData = false; 
        }else{
          this.snackBarService.showError('An error has occurred. Please try again later.'); 
          this.navigationPreviousPage.back();
          this.isLoadingData = false; 
        } 
      }, (error) => {
        if (error.status == 400) {
          this.snackBarService.showError("Invalid input!");
          this.isLoadingData = false;
        }
        else {
          this.isLoadingData = false;
        }
      });
    } else {
      this.solarFormsService.updateRTAFormDetails(RTAFormInfo)
      .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data) {
            this.snackBarService.showSuccess(`RTA saved successfully.`);
            this.navigationPreviousPage.back();
            this.isLoadingData = false;
          } else {
            this.snackBarService.showError('An error has occurred. Please try again later.');
            this.navigationPreviousPage.back();
            this.isLoadingData = false;
          }
        }, (error) => {
          if (error.status == 400) {
            this.snackBarService.showError("Invalid input!");
            this.isLoadingData = false;
          }
          else {
            this.isLoadingData = false;
          }
        });
    }
    
  }

  getRTAFormInfo() {
  
  let RTADetails: RTADetails;
  if(this.isRTAEditForm) {
    RTADetails = {
      generalRTAInformation: {
        rtaNumber: this.generalRTAInformation.rtaNumber,
        rtaRevison: this.generalRTAInformation.rtaRevison,
        submittedBy: this.generalRTAInformation.submittedBy,
        submittedDate: this.generalRTAInformation.submittedDate,
        rtaStatus:  this.isRTAFormSubmit ? 'Submitted' : this.persistedRtaStatus,
        supplierPreference: this.supplierReference.value,
        // Windchill contract header fields (PBI 368007-Part2). Windchill sets
        // `number` itself on integration; carry through any existing value.
        number: this.generalRTAInformation.number,
        partNumber: this.partNumber.value,
        department: this.department.value,
        valueStream: this.valueStream.value,
        routingType: this.routingType.value,
        productModel: this.productModel.value,
      },
      rtaRequestDetails: {
        supplierCode: this.supplierOrCamName.value.organizationCode,
        supplierName: this.supplierOrCamName.value.supplierName,
        phone: this.phone.value,
        email: this.email.value == null ? 'null' : this.email.value,
        solarPurchaseOrderNumber: this.solarPurchaseOrder.value,
        solarProductionNumber: this.solarProductionOrder.value,
        operationNumber: this.operation.value,
        isNonconformingConditionCTQ: (this.isNonconformingConditionCtq.value == 'Yes' ? true : (this.isNonconformingConditionCtq.value == 'No' ? false : null)),
        // isNonconformingConditionCTQ: this.isNonconformingConditionCtq.value == 'Yes' ? true : false,
        causeOfNonConformance: this.causeOfNonconformance.value,
        proposeCorrection: this.proposedCorrection.value,
        comments: this.commentsOrSrp.value,
        proposedDuration: {
          quantityOfNonconformingParts: this.quantityOfNonconformingParts.value,
          fromDate: this.fromDate.value,
          toDate: this.toDate.value,
        }
      },
      RTACurrentCondition: {
        CurrentConditions: this.currentCondition.controls.map((control: UntypedFormGroup) => {
          return {
            drawingSpecRequirement: control.get('drawingOrSpecRequirement').value,
            bluePrintZoneSpecSection: control.get('bluePrintZoneSection').value,
            actualCondition: control.get('actualCondition').value,
            quantity: control.get('quantity').value,
            serialNumber: control.get('serialNumber').value,
            AdditionalComments: control.get('additionalComments').value,
            // Solar-owned; echo Windchill's value but never the '-' row placeholder.
            disposition: this.solarRowValue(control.get('disposition').value),
            dispositionNotes: this.solarRowValue(control.get('dispositionNotes').value),
          };
        }),
        RTAAttachments: this.linkList.map(val => {
          return {
            linkTitle: val.linkTitle,
            linkAddress: val.linkAddress
          }
        }),
      },
      rtsDisposition: {
        additionalSolarComments: this.rtaDisposition?.additionalSolarComments,
        changeRequest: this.rtaDisposition?.changeRequest,
        // Solar MRB decision (paper 4040: "For Solar Authorized MRB use only"); echoed
        // back from the read, never entered by the supplier.
        deviationPermit: this.rtaDisposition?.deviationPermit,
        partIdentificationLocationMethod: this.rtaDisposition?.partIdentificationLocationMethod,
        problemReportECRNo: this.rtaDisposition?.problemReportECRNo,
        solarApprovedPeriod: this.rtaDisposition?.solarApprovedPeriod,
        totalQuantityOfParts: this.rtaDisposition?.totalQuantityOfParts,
        advancedRejectNotice: this.rtaDisposition?.advancedRejectNotice,
        associatedPPAP: this.rtaDisposition?.associatedPPAP,
        associatedOHRS: this.rtaDisposition?.associatedOHRS,
        applicableEngineeringSpecs: this.rtaDisposition?.applicableEngineeringSpecs,
      }
    } 
  } else {
    RTADetails = {
      generalRTAInformation: {
        rtaNumber: '',
        rtaRevison: '',
        submittedBy: '',
        submittedDate: '',
        rtaStatus: this.isRTASaveDraft ? 'Draft' : 'Submitted',
        supplierPreference: this.supplierReference.value,
        // Windchill contract header fields (PBI 368007-Part2).
        partNumber: this.partNumber.value,
        department: this.department.value,
        valueStream: this.valueStream.value,
        routingType: this.routingType.value,
        productModel: this.productModel.value,
      },
      rtaRequestDetails: {
        supplierCode: this.supplierOrCamName.value.organizationCode,
        supplierName: this.supplierOrCamName.value.supplierName,
        phone: this.phone.value,
        email: this.email.value,
        solarPurchaseOrderNumber: this.solarPurchaseOrder.value,
        solarProductionNumber: this.solarProductionOrder.value,
        operationNumber: this.operation.value,
        isNonconformingConditionCTQ: (this.isNonconformingConditionCtq.value == 'Yes' ? true : (this.isNonconformingConditionCtq.value == 'No' ? false : null)),
       // isNonconformingConditionCTQ: this.isNonconformingConditionCtq.value == 'Yes' ? true : false,
        causeOfNonConformance: this.causeOfNonconformance.value,
        proposeCorrection: this.proposedCorrection.value,
        comments: this.commentsOrSrp.value,
        proposedDuration: {
          quantityOfNonconformingParts: this.quantityOfNonconformingParts.value,
          fromDate: this.fromDate.value,
          toDate: this.toDate.value,
        }
      },
      RTACurrentCondition: {
        CurrentConditions: this.currentCondition.controls.map((control: UntypedFormGroup) => {
          return {
            drawingSpecRequirement: control.get('drawingOrSpecRequirement').value,
            bluePrintZoneSpecSection: control.get('bluePrintZoneSection').value,
            actualCondition: control.get('actualCondition').value,
            quantity: control.get('quantity').value,
            serialNumber: control.get('serialNumber').value,
            AdditionalComments: control.get('additionalComments').value,
            disposition: '',
            dispositionNotes: '',
          };
        }),
        RTAAttachments: this.linkList.map(val => {
          return {
            linkTitle: val.linkTitle,
            linkAddress: val.linkAddress
          }
        }),
      },
      rtsDisposition: {
        deviationPermit: null,
        additionalSolarComments: null,
        changeRequest: null,
        partIdentificationLocationMethod: null,
        problemReportECRNo: null,
        solarApprovedPeriod: null,
        totalQuantityOfParts: null,
        advancedRejectNotice: null,
        associatedPPAP: null,
        associatedOHRS: null,
        applicableEngineeringSpecs: null
      }
    } 
  }
   
    return RTADetails;
  }

  onKeyDown(event: KeyboardEvent) {
    const keyCode = event.keyCode || event.which;
    if([8, 46, 37, 39].indexOf(keyCode) !== -1) {
      return;
    }
    if(keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }

  fileUpload() {
    document.getElementById("filesUpload").click();
  }

  addRemoveValidators(): void {
    this.acceptedFileExtensions = [];
      this.documentsService
          .getValidFileExtensions()
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (response:[]) => {
              this.acceptedFileExtensions.push(response);
            })
    }

  onFileSelected(event) {
    let fileValue = this.filesUploadAttachment.value;
    let abc = this.supplierOrCamName.value.organizationCode+'_'+event.target.files[0].name;
    let modifiedName = new File([event.target.files[0]], abc);

    let fileExtensionValue = fileValue.split('.');
     for (let i = 0; i < this.linkList.length; i++) {
      if (this.linkList[i].linkAddress === event.target.files[0].name) {
        this.snackBarService.showError(event.target.files[0].name + ' ' + 'file is Already uploaded');
      }
    }

    if (fileValue) { 
      let fileSize = this.linkList.reduce((n, { linksize }) => n + linksize, 0);
      if (fileSize > 1000000000) {
        this.snackBarService.showError('Only attachments up to 1GB are allowed');
      } else {
        if (this.linkList.length < 100) {
          const file: File = modifiedName;
          let formData: FormData = new FormData();
          let linkList: any = new Object();
          let fileExtensionValueWithdot = '.'+fileExtensionValue[1];
          formData.append("file", file);
          if(this.supplierOrCamName.value){
            formData.append("SupplierCode", this.supplierOrCamName.value.organizationCode);
            formData.append("SupplierName", this.supplierOrCamName.value.supplierName)
          }
             if((this.acceptedFileExtensions[0].indexOf(fileExtensionValue[1].toString()) > -1) || (this.acceptedFileExtensions[0].indexOf(fileExtensionValueWithdot.toString()) > -1)){
              this.solarFormsService.uploadRTAContent(formData).pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (response: string) => {
                    if (response) {
                      this.linkListAddress = response;
                      linkList.linkTitle = event.target.files[0].name;
                     // linkList.linksize = event.target.files[0].size;
                      linkList.linkAddress = this.linkListAddress;
                      this.linkList.push(linkList);
                    }
                    this.filesUploadAttachment.patchValue("");
                  },
                  (error) => {
                    console.log(error)
                  });
              }    
            else{
              this.snackBarService.showError(' Not Valid File extension');
            }
         }
        else {
          this.snackBarService.showError('Only 100 attachments can be added');
          return;
        }
      }
    }
  }

  removeLinkList(index) {
        this.linkList.splice(index, 1);
  }

  onClickBackOrClose(){
    if(this.isRTAFormDirty) {
      const message = 'Changes you made may not be saved.';
      const res = window.confirm(message);
      if(res) {
        this.navigationPreviousPage.back();
      }
    } else {
      this.navigationPreviousPage.back();
    }
  }

  get supplierReference() {
    return this.RTAForm.get('supplierReference') as UntypedFormControl;
  }

  get rtaRequestDetails() {
    return this.RTAForm.get('rtaRequestDetails') as UntypedFormGroup;
  }

  get supplierOrCamName() {
    return this.RTAForm.get('rtaRequestDetails.supplierOrCamName') as UntypedFormControl;
  }

  get phone() {
    return this.RTAForm.get('rtaRequestDetails.phone') as UntypedFormControl;
  }

  get email() {
    return this.RTAForm.get('rtaRequestDetails.email') as UntypedFormControl;
  }
  
  get solarPurchaseOrder() {
    return this.RTAForm.get('rtaRequestDetails.solarPurchaseOrder') as UntypedFormControl;
  }

  get solarProductionOrder() {
    return this.RTAForm.get('rtaRequestDetails.solarProductionOrder') as UntypedFormControl;
  }

  get operation() {
    return this.RTAForm.get('rtaRequestDetails.operation') as UntypedFormControl;
  }

  get isNonconformingConditionCtq() {
    return this.RTAForm.get('rtaRequestDetails.isNonconformingConditionCtq') as UntypedFormControl;
  }

  get causeOfNonconformance() {
    return this.RTAForm.get('rtaRequestDetails.causeOfNonconformance') as UntypedFormControl;
  }

  get proposedCorrection() {
    return this.RTAForm.get('rtaRequestDetails.proposedCorrection') as UntypedFormControl;
  }

  get commentsOrSrp() {
    return this.RTAForm.get('rtaRequestDetails.commentsOrSrp') as UntypedFormControl;
  }

  get currentCondition() {
    return this.RTAForm.get('currentCondition') as UntypedFormArray;
  }

  get quantityOfNonconformingParts() {
    return this.RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts') as UntypedFormControl;
  }

  get fromDate() {
    return this.RTAForm.get('rtaRequestDetails.fromDate') as UntypedFormControl;
  }

  get toDate() {
    return this.RTAForm.get('rtaRequestDetails.toDate') as UntypedFormControl;
  }

  get filesUploadAttachment() {
    return this.RTAForm.get('filesUploadAttachment') as UntypedFormControl;
  }

  // Windchill contract header field getters (PBI 368007-Part2).
  get partNumber() {
    return this.RTAForm.get('rtaRequestDetails.partNumber') as UntypedFormControl;
  }
  get department() {
    return this.RTAForm.get('rtaRequestDetails.department') as UntypedFormControl;
  }
  get valueStream() {
    return this.RTAForm.get('rtaRequestDetails.valueStream') as UntypedFormControl;
  }
  get routingType() {
    return this.RTAForm.get('rtaRequestDetails.routingType') as UntypedFormControl;
  }
  get productModel() {
    return this.RTAForm.get('rtaRequestDetails.productModel') as UntypedFormControl;
  }

  private solarRowValue(value: any): string {
    const v = (value ?? '').toString();
    return v === '-' ? '' : v;
  }

  isRowDispositioned(index: number): boolean {
    return !!this.solarRowValue(this.currentCondition?.at(index)?.get('disposition')?.value);
  }

}
